import { Injectable } from '@angular/core';
import { idNameItem,OpenWinLoadOption } from 'jk-service';
import { StkmwServicePkg } from './stkmwPkg.service';

/**
 * 交易所基本資料
 */
@Injectable({
  providedIn: 'root'
})
export class StkmwService extends StkmwServicePkg {
    constructor() {
      super();
      this.getIdNameList();
    }
    getIdNameList() {
      let r: OpenWinLoadOption = {
        mainTable: 'STKMW',
        item: 'S01',
        type: 'S',
        params: [],
        list: this.idNameList,
      };
      this.orm.doOpenwinLoad(r);
      //return this.idNameList;
    }
    gotoKey(key: string): void {
      this.item = this.idNameList.find((item) => item.id === key);
    }
  }
